module.exports = __webpack_public_path__ + "img/far_day_cyl75_axis45.bc565a7f.jpg";